import React from 'react';

export const ticketsAtMinPrice = ({fill = '#C23A77', width = '14px', height = '14px'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill={fill} fillRule="evenodd">
        <path d="M43.4,0 L31.4,0 L30.824,0.96 C29.48,3.36 26.888,4.8 24.2,4.8 C21.512,4.8 18.92,3.36 17.576,0.96 L17,0 L5,0 L5,48 L43.4,48 L43.4,17.952 L35.72,14.112 L43.4,14.112 L43.4,0 L43.4,0 Z M30.728,33.792 L24.296,30.432 L17.96,33.888 L19.112,26.784 L13.928,21.792 L21.128,20.736 L24.296,14.208 L27.56,20.64 L34.76,21.6 L29.576,26.688 L30.728,33.792 L30.728,33.792 Z" />
      </g>
    </svg>
  );
};

export const totalViews = ({fill = '#C23A77', width = '16px', height = '18px'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill={fill} fillRule="evenodd">
        <path d="M9.63051471,4.52941176 C9.96139706,5.6875 9.76838235,8.03125 8.47242647,8.00367647 C7.67279412,7.97610294 7.31433824,7.36948529 7.36948529,6.45955882 C7.39705882,6.15625 7.45220588,5.85294118 7.50735294,5.54963235 C7.70036765,4.55698529 7.92095588,3.42647059 6.70772059,1.82720588 L6.07352941,1 L5.6875,1.99264706 C5.49448529,2.59926471 4.88786765,3.20588235 4.19852941,3.89522059 C2.84742647,5.30147059 1,7.17647059 1,10.4852941 C1,13.5183824 3.48161765,16 6.51470588,16 C6.18382353,15.3106618 5.96323529,14.5386029 5.96323529,13.7113971 C5.96323529,13.5735294 5.96323529,13.4356618 5.99080882,13.2977941 C6.40441176,14.3180147 7.14889706,15.2003676 8.08639706,15.7794118 C10.375,15.0900735 12.0294118,12.9944853 12.0294118,10.4852941 C12.0294118,9.49264706 11.8915441,7.06617647 9.63051471,4.52941176 L9.63051471,4.52941176 Z" />
      </g>
    </svg>
  );
};

export const ticketsLeft = ({fill = '#C23A77', width = '13px', height = '14px'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill={fill} fillRule="evenodd">
        <path d="M5.468 10.512c-2.379 0-4.323-1.914-4.323-4.255 0-2.342 1.944-4.255 4.323-4.255 2.38 0 4.323 1.913 4.323 4.255 0 2.341-1.944 4.255-4.323 4.255m-.026-9.505c-2.941 0-5.32 2.342-5.32 5.237s2.404 5.262 5.346 5.262 5.347-2.367 5.347-5.262c0-2.895-2.405-5.237-5.373-5.237" />
        <path d="M7.63 6.956H4.955V3.62H5.98v2.33h1.65z" />
      </g>
    </svg>
  );
};

export const hotEvent = ({fill = '#D94185', width = '12px', height = '12px'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="SM-(320)----NBA-Top-Event-Copy" transform="translate(-283.000000, -458.000000)" fill={fill}>
          <g id="Group-8" transform="translate(0.000000, 438.000000)">
            <g id="Group-7" transform="translate(216.000000, 19.000000)">
              <g id="Group-6" transform="translate(67.000000, 1.000000)">
                <polygon
                  id="favorites-filled-30px-copy"
                  points="12 4.58823529 7.848 3.95798319 6 0 4.152 3.95798319 0 4.58823529 3 7.66386555 2.28 12 6 9.95798319 9.72 12 9 7.66386555"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const sellingFast = totalViews;
